import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { Wordmark } from "./Motion";
import { subscribe } from "../lib/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const onSub = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const r = await subscribe(email);
      setDone(true);
      toast.success(`Code ${r.code} unlocked`);
    } catch { toast.error("Enter a valid email"); }
  };

  return (
    <footer className="border-t border-line bg-bg" data-testid="footer">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-16 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1.3fr]">
        <div>
          <Wordmark className="text-2xl" />
          <p className="mt-5 text-graytx text-sm max-w-xs leading-relaxed">
            Sun-faded surf culture and vintage thrift, rebuilt into pieces that feel already lived in.
          </p>
          <div className="flex gap-4 mt-6 text-cream/70">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="social-instagram" className="hover:text-cs-yellow transition-colors duration-200"><Instagram size={18} /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" data-testid="social-twitter" className="hover:text-cs-blue transition-colors duration-200"><Twitter size={18} /></a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" data-testid="social-youtube" className="hover:text-cs-red transition-colors duration-200"><Youtube size={18} /></a>
          </div>
        </div>

        <div className="font-mono text-[11px] uppercase tracking-[0.18em] flex flex-col gap-3">
          <span className="text-graytx">Shop</span>
          <Link to="/shop" className="hover:text-cs-yellow transition-colors duration-200">First Drop</Link>
          <Link to="/lookbook" className="hover:text-cs-yellow transition-colors duration-200">Lookbook</Link>
          <Link to="/our-story" className="hover:text-cs-yellow transition-colors duration-200">Our Story</Link>
          <Link to="/mission" className="hover:text-cs-yellow transition-colors duration-200">Mission</Link>
        </div>

        <div className="font-mono text-[11px] uppercase tracking-[0.18em] flex flex-col gap-3">
          <span className="text-graytx">Help</span>
          <Link to="/shipping-returns" className="hover:text-cs-yellow transition-colors duration-200">Shipping & Returns</Link>
          <Link to="/faq" className="hover:text-cs-yellow transition-colors duration-200">FAQ</Link>
          <Link to="/contact" className="hover:text-cs-yellow transition-colors duration-200">Contact</Link>
          <Link to="/account" className="hover:text-cs-yellow transition-colors duration-200">Account</Link>
        </div>

        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-graytx">Newsletter</p>
          {done ? (
            <p className="mt-4 text-sm text-cs-green" data-testid="footer-sub-done">Subscribed — check your inbox for early access.</p>
          ) : (
            <form onSubmit={onSub} className="mt-4 flex border-b border-line focus-within:border-cream transition-colors duration-200" data-testid="footer-newsletter">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="you@email.com"
                data-testid="footer-email-input"
                className="flex-1 bg-transparent py-2 text-sm outline-none placeholder:text-graytx" />
              <button data-testid="footer-sub-btn" className="font-mono text-[11px] uppercase tracking-[0.18em] px-2">Join</button>
            </form>
          )}
        </div>
      </div>
      <div className="border-t border-line py-5 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-graytx">
        © {new Date().getFullYear()} Covertswag — 8% of every order fights the cold
      </div>
    </footer>
  );
};
